module.exports = __webpack_public_path__ + "img/upload-file-white.3b21e1e1.svg";